import { render, staticRenderFns } from "./NoMedia.vue?vue&type=template&id=33ae4bad&"
import script from "./NoMedia.vue?vue&type=script&lang=js&"
export * from "./NoMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports